exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card-b0cf3455{padding:50px 40px 60px 40px;text-align:center}.graphic-bf1bd91a{margin-bottom:30px}.leadText-273fcf83{margin-bottom:30px}.trialText-c0fe6a43{margin-top:40px;margin-bottom:30px}\n", ""]);

// Exports
exports.locals = {
	"card": "card-b0cf3455",
	"graphic": "graphic-bf1bd91a",
	"leadText": "leadText-273fcf83",
	"trialText": "trialText-c0fe6a43"
};